import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { LogoMark } from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tarbyte_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:border-[#00F0FF]/60 focus:outline-none focus:ring-2 focus:ring-[#00F0FF]/30";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050811] px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#0A0F1C] p-8">
        <div className="mb-8 flex flex-col items-center gap-3">
          <LogoMark size={44} />
          <h1 className="font-display text-xl font-bold text-white">Tarbyte Admin</h1>
        </div>
        <label htmlFor="al-email" className="mb-2 block text-xs font-semibold uppercase tracking-widest text-slate-400">Email</label>
        <input id="al-email" type="email" data-testid="admin-email-input" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} required />
        <label htmlFor="al-password" className="mb-2 mt-5 block text-xs font-semibold uppercase tracking-widest text-slate-400">Password</label>
        <input id="al-password" type="password" data-testid="admin-password-input" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} required />
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit-btn"
          className="mt-7 flex w-full items-center justify-center gap-2 rounded-full bg-[#00F0FF] px-6 py-3.5 text-sm font-bold text-[#050811] transition-shadow duration-300 hover:shadow-[0_0_28px_rgba(0,240,255,0.55)] disabled:opacity-60"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          Sign in
        </button>
        <Link to="/" data-testid="admin-back-home-link" className="mt-5 block text-center text-xs text-slate-500 hover:text-[#00F0FF]">
          ← Back to website
        </Link>
      </form>
    </div>
  );
}
